import { HTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

export type ICardHeaderProps = HTMLAttributes<HTMLDivElement>;

export function CardHeader({
  children,
  className,
  ...rest
}: PropsWithChildren<ICardHeaderProps>) {
  return (
    <div className={twMerge('grid', className)} {...rest}>
      {children}
    </div>
  );
}
